
    import {Component, Inject, Vue} from 'vue-property-decorator';
    import {getEnumMap, showWarning, showImportantMessage, showConfirm, showError, isEmptyOrWhiteSpace} from "@/utils/Common";
    import {API_UPLOAD_BUSINESSLICENSE, API_USER_DELETEAPPLY, API_USER_UPGRADEAPPLY, API_USER_EXPIREAPPLY, API_SYSLOG_EXPIREUSERLOGLIST} from "@/configs/Apis";
    import {Fetcher as Ajax} from "@/utils/Request";
    import {MSG_FREE_USER_UPGRADE} from "@/configs/Consts";
    import moment from "moment";
    import PaymentMethod from "@/views/base/PaymentMethod.vue";

    @Component({
        components: {PaymentMethod}
    })
    export default class AccountInfo extends Vue {



    }
